/**
 * Enums for S3 file storage destinations.
 */
export enum S3DestinationFolder {
  CONVERSATIONS = 1,
  NGS = 2,
  PRE_INGESTION = 3,
  TRANSLATION = 4,
}

export enum TranslationFileType {
  SOURCE = 1,
  REFERENCE = 2,
  TARGET = 3,
}
